import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import {
  SENDER_REMISSION_GUIDE_CLOSURE_STATUS,
  SENDER_REMISSION_GUIDE_EXIT_REASON,
  SENDER_REMISSION_GUIDE_ITEM_STATUS,
  STATUS_TRANSLATIONS,
} from '../../../../../config/constants';
import { senderRemissionGuidePropTypes } from '../proptypes/ManualSenderRemissionGuidePropTypes';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_FORMAT } from '../../../../../config/locale';
import { BILLING_PATH } from '../../../../../config/paths';
import Table from '../../../../common/Table';
import { SENDER_REMISSION_GUIDE_ITEM_COLUMNS } from '../../../../../config/columns';
import EnumStatus from '../../../../common/EnumStatus';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';

const ManualSenderRemissionGuideBasicInformationResource = ({
  guideNumber,
  sender,
  consignee,
  sourceName,
  destinationName,
  createDate,
  description,
  billProcessId,
  billProcessStatus,
  senderRemissionGuideItemList,
  returnPickupUserId,
  returnPickupUser,
  status,
  exitReason,
  closureStatus,
}) => (
  <>
    <ResourceProperty label="Número de Guía:">{guideNumber}</ResourceProperty>
    <ResourceProperty label="Remitente:">{sender}</ResourceProperty>
    <ResourceProperty label="Consignado:">{consignee}</ResourceProperty>
    <ResourceProperty label="Origen:">{sourceName}</ResourceProperty>
    <ResourceProperty label="Destino:">{destinationName}</ResourceProperty>
    <ResourceProperty label="Creado el:">
      {tzNormalizeDate({
        date: createDate,
        format: DATE_FORMAT,
      })}
    </ResourceProperty>
    <ResourceProperty label="Descripción:">{description}</ResourceProperty>
    <ResourceProperty label="Motivo de Salida:">
      <EnumStatus
        enumObject={SENDER_REMISSION_GUIDE_EXIT_REASON}
        enumValue={exitReason}
      />
    </ResourceProperty>
    <ResourceProperty label="Datos de la Guía:">
      {billProcessId ? (
        <>
          <a
            href={`${BILLING_PATH}/${billProcessId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {billProcessId}
          </a>
          {billProcessStatus === 'ERROR' && (
            // eslint-disable-next-line jsx-a11y/accessible-emoji
            <div style={{ marginTop: '4px', color: 'red' }}>
              El proceso presentó un error, por favor revisa el enlace.
            </div>
          )}
        </>
      ) : (
        '-'
      )}
    </ResourceProperty>
    <ResourceProperty label="Estado de Guía:">
      {STATUS_TRANSLATIONS[billProcessStatus]}
    </ResourceProperty>
    {status && (
      <ResourceProperty label="Estado de Recepción:">
        <EnumStatus
          enumObject={SENDER_REMISSION_GUIDE_ITEM_STATUS}
          enumValue={status}
        />
      </ResourceProperty>
    )}{' '}
    {closureStatus && (
      <ResourceProperty label="Estado de Cierre:">
        <EnumStatus
          enumObject={SENDER_REMISSION_GUIDE_CLOSURE_STATUS}
          enumValue={closureStatus}
        />
      </ResourceProperty>
    )}
    {returnPickupUserId && (
      <ResourceProperty label="Usuario que Receciono:">
        {returnPickupUser ? returnPickupUser.customer.fullName : '-'}
      </ResourceProperty>
    )}
    {Array.isArray(senderRemissionGuideItemList) &&
      senderRemissionGuideItemList.length > 0 && (
        <Table
          columns={SENDER_REMISSION_GUIDE_ITEM_COLUMNS}
          data={senderRemissionGuideItemList}
          defaultPageSize={10}
          defaultFilterMethod={filterMethodCaseInsensitive}
          manual={false}
        />
      )}
  </>
);

ManualSenderRemissionGuideBasicInformationResource.propTypes =
  senderRemissionGuidePropTypes;

export default ManualSenderRemissionGuideBasicInformationResource;
